
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Modal, Button, Select } from 'ant-design-vue';
import { namespace } from 'vuex-class';

const userModule = namespace('user');
// 10分钟
const MAXTIME = 10;

@Component({
  components: {
    AModal: Modal,
    AButton: Button,
    ASelect: Select,
    ASelectOption: Select.Option,
  },
})
export default class ClassWarnDialog extends Vue {
  @userModule.Getter('userInfo') userInfo: any;

  @userModule.Getter('getAccountStatus') getAccountStatus: any;

  // 是否显示弹框
  private visible: boolean = false;

  // 班级信息
  private comingClass: any = {};

  // 当前讲次
  private currLessonId: number = 0;

  // 当前讲次num
  private currLessonNum: number = 0;

  // 当前讲次视频类型
  // private currVideoType: number = 0;

  // 定时器
  private comingClassTimeout: number = 0;

  // 定时器
  private comingClassInterval: number = 0;

  get allowAccess(): boolean {
    return (
      this.getAccountStatus === 2 || this.getAccountStatus === 4 || this.getAccountStatus === 5
    );
  }

  // 拼接授课url
  private get getShoukeUrl(): string {
    return `${process.env.VUE_APP_JUMPURL}/shouke.html#/
              ?classId=${this.comingClass.classId}
              &lessonId=${this.currLessonId}
              &num=${this.currLessonNum}`;
  }

  @Watch('comingClass')
  handleComingClassChange(val: any) {
    if (val && val.comingMinute > 0 && val.comingMinute <= MAXTIME) {
      this.visible = true;
    } else {
      this.visible = false;
    }
  }

  // 轮训判断逻辑
  private comingClassCountdown() {
    if (this.comingClassTimeout) {
      clearTimeout(this.comingClassTimeout);
    }

    if (this.comingClassInterval) {
      clearInterval(this.comingClassInterval);
    }

    const minute: number = this.comingClass.comingMinute;
    const oneMinute: number = 1000 * 60;
    if (minute > 10) {
      // 大于10分钟，延迟等到10分钟时，每一分钟轮训一次
      this.comingClassTimeout = setTimeout(() => {
        this.intervalTimer(oneMinute);
      }, (minute - 10 - 1) * oneMinute);
    } else if (minute <= 10 && minute > 0) {
      // 小于10分钟时，每分钟轮训一次
      this.intervalTimer(oneMinute);
    }
  }

  private intervalTimer(oneMinute: number) {
    this.comingClassInterval = setInterval(() => {
      this.setComingClass();
    }, oneMinute);
  }

  private setComingClass() {
    this.comingClass = {
      ...this.comingClass,
      comingMinute: this.comingClass.comingMinute - 1,
    };
  }

  // 获取即将上课的班级
  private getComingClass() {
    this.$service.bk.getComingClass().then((result: any) => {
      if (result && result.comingMinute > 0) {
        this.comingClass = result;
        this.visible = true;
        this.comingClassCountdown();
        this.$nextTick(() => {
          this.init();
        });
      }
    });
  }

  // 关闭弹框
  private handleCancel() {
    this.visible = false;
    this.$utils.sendAction('index', 'index', 'id-5');
  }

  // 去上课
  private handleGoClass() {
    this.visible = false;
    const url: string = this.$utils.trimAll(`${this.getShoukeUrl}&model=kejian&newDiyFlag=${this.comingClass.newDiyFlag}`);
    this.$utils.sendAction('index', 'index', 'id-4');

    window.open(url, '_blank');
  }

  // 切换讲次
  private handleChange(lessonId: number) {
    this.currLessonId = lessonId;
    const result = this.comingClass.lessonList.find(
      (item: any) => item.lessonId === lessonId,
    );
    if (result) {
      this.currLessonNum = result.lessonNum;
      // this.currVideoType = result.videoType;
    }
    this.$utils.sendAction('index', 'index', 'id-3');
  }

  // 开始去上课
  // private beginClazz() {
  //   const data = {
  //     lessonId: this.currLessonId,
  //     classId: this.comingClass.classId,
  //   };
  //   this.$service.sk.startLesson(data);
  // }

  // 初始化数据
  private init() {
    this.currLessonId = this.comingClass.comingLessonId;
    this.currLessonNum = this.comingClass.comingLessonNum;
    // this.currVideoType = this.comingClass.videoType;
  }

  private mounted() {
    if (!this.allowAccess) {
      this.getComingClass();
    }
  }
}
